import React, { Component, PropTypes } from 'react'
import { lang } from '../strings'

export default class Error extends Component {
  render() {
    return (
      <div className='mp-popup-container'>
        <div className='mp-popup-content'>
          <a href='#' className='mp-close' onClick={this.close}>
            &times;
          </a>
          <h4 className='h5 color-dark-blue'>{lang.error.title}</h4>
          <p>{lang.error.description}</p>
          <button type='button' className='button' onClick={this.close}>
            {lang.error.close}
          </button>
        </div>
      </div>
    )
  }

  close = ev => {
    ev.preventDefault()
    this.props.onClose()
  }
}

Error.propTypes = {
  onClose: PropTypes.func.isRequired,
}
